import React, { useEffect, useRef } from 'react';

const SnackBar = ({type, msg}) => {
    const snacker = useRef(null);
    useEffect(() => {
        console.log('loaded');
        snacker.current.classList.add('show'); 
        setTimeout(() => { 
            console.log('timeout');
           snacker.current.className = ''; //.replace('show', '');
           console.log(snacker.current.className);
        }, 3000);
    }, []);
    return (
        <div id="snackbar" ref={snacker} >
            {msg}
        </div>
    )
}
export default SnackBar;
